import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\vhosts\\paykanpars.com\\httpdocs\\src\\app\\(pages)\\(general)\\product\\components\\product-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwrConfig"] */ "E:\\vhosts\\paykanpars.com\\httpdocs\\src\\lib\\swr-config.tsx");
